import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetLabParamGroup,
	adminGetAllLabParamGroups,
	resetFocusLabParamGroup,
	initNewLabParamGroup,
	adminPatchLabParamGroup,
	adminPostLabParamGroup,
	adminDeleteLabParamGroup
} from 'services/labParamGroup';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/LabParamGroups/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	name: Yup.string().required('Champ requis'),
	format: Yup.string().required('Champ requis')
});

class LabParamGroupsAdmin extends Component {
	

	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusLabParamGroup();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllLabParamGroups();
	};

	focusOnElement = elt => {
		this.props.adminGetLabParamGroup(elt);
	};

	onAddClick = () => {
		this.props.initNewLabParamGroup();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostLabParamGroup(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchLabParamGroup(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteLabParamGroup(this.props.labParamGroups.focus.data);
	};

	render() {
		const { labParamGroups } = this.props;
		const { focus, list } = labParamGroups;
		const labParamGroup = focus.data;
		const newLabParamGroup =
			labParamGroup !== null && labParamGroup.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={labParamGroups.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity='Groupe de paramétrage laboratoire'
					addButtonText='Nouveau groupe'
					onAddButtonClick={this.onAddClick}
					defaultLabel={e => e.name}
					groupField={false}
					focusedEltId={labParamGroup}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity='Groupe de paramétrage laboratoire'
					icon='info'
				>
					{labParamGroup !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: labParamGroup.id,
								name: labParamGroup.name || '',
								format: labParamGroup.format || ''
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusLabParamGroup}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newLabParamGroup ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newLabParamGroup && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={e => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm />
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex'
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0'
	}
};

const mapStateToProps = state => {
	return {
		labParamGroups: state.admin.labParamGroups
	};
};

const mapDispatchToProps = {
	adminGetAllLabParamGroups,
	adminGetLabParamGroup,
	adminPatchLabParamGroup,
	adminDeleteLabParamGroup,
	resetFocusLabParamGroup,
	adminPostLabParamGroup,
	initNewLabParamGroup
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(LabParamGroupsAdmin);
